import { useEffect, useState } from "react";
import { BizcoverIndiaFigmaFooter } from "../../components/marketing/BizcoverIndiaFigmaFooter";

export default function BizcoverIndiaFigmaFooterPreview() {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  useEffect(() => {
    const urbanistId = "urbanist-figma-footer";
    if (!document.getElementById(urbanistId)) {
      const link = document.createElement("link");
      link.id = urbanistId;
      link.rel = "stylesheet";
      link.href =
        "https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,400;0,9..40,600&family=Urbanist:wght@700&display=swap";
      document.head.appendChild(link);
    }
  }, []);

  return (
    <div className="min-h-screen overflow-x-hidden bg-[#f4f6f8]">
      <BizcoverIndiaFigmaFooter
        email={email}
        onEmailChange={(value) => {
          setSubscribed(false);
          setEmail(value);
        }}
        onSubscribe={(value) => {
          if (!value.trim()) return;
          setSubscribed(true);
        }}
      />
      <div className="mx-auto max-w-3xl px-4 py-8 text-center text-sm text-[#637381]">
        <p className="font-['DM_Sans',sans-serif]">
          {subscribed
            ? "Newsletter submit action was captured in preview mode."
            : "Preview route uses live footer content and link redirections from the old footer config."}
        </p>
      </div>
    </div>
  );
}
